import { lazy } from "react";

import { PAGES_URL } from "../constants/enum";

export const Login = lazy(() => import("./login/LoginPage"));

export const PreLogin = lazy(() => import("./login/LoginPage"));

export const ForgotPassword = lazy(
  () => import("./forgot-password/ForgotPassword"),
);
// export const TermAndConditions = lazy(() => import("./term/TermAndConditions"));
export const NotFound = lazy(() => import("./404-not-found/NotFound"));
export const Dashboard = lazy(() => import("./dashboard/Dashboard"));
export const StylesGuide = lazy(() => import("./styles-guide/StylesGuide"));
export const TransferByPhone = lazy(
  () => import("./transfer-money/transfer-by-phone/TransferByPhone"),
);
export const TransferByAccount = lazy(
  () => import("./transfer-money/transfer-by-account/TransferByAccount"),
);
export const TransferByCard = lazy(
  () => import("./transfer-money/transfer-by-card/TransferByCard"),
);
export const TransferByBatch = lazy(
  () => import("./transfer-money/transfer-by-batch/TransferByBatch"),
);
export const TransInternational = lazy(
  () => import("./transfer-money/transfer-international/TransInternational"),
);
export const CardTransactionList = lazy(
  () =>
    import("./manage-transaction/card-transaction-list/CardTransactionList"),
);
export const TransactionList = lazy(
  () => import("./manage-transaction/transaction-list/TransactionList"),
);
export const TransactionHistory = lazy(
  () => import("./manage-transaction/transaction-history/TransactionHistory"),
);
export const TransactionDetail = lazy(
  () => import("./manage-transaction/transaction-detail/TransactionDetail"),
);
export const BeneficiaryTemplate = lazy(
  () => import("./manage-transaction/beneficiary-template/BeneficiaryTemplate"),
);
export const AccountsList = lazy(
  () => import("./accounts/accounts-list/AccountsListPage"),
);
export const CardList = lazy(() => import("./cards/cards-list/CardsListPage"));
export const CardTransactionHistoryPage = lazy(
  () =>
    import("./cards/card-transaction-history/CardTransactionHistoryPage"),
);
export const CardTransactionDetailPage = lazy(
  () => import("./cards/card-transaction-detail/CardTransactionDetailPage"),
);
export const CardLimitSettingPage = lazy(
  () => import("./cards/card-limit-setting/CardLimitSettingPage"),
);
export const CreditCardStatementPage = lazy(
  () => import("./cards/credit-card-statement/CreditCardStatementPage"),
);
export const CreditCardStatementViewPage = lazy(
  () => import("./cards/credit-card-statement/CreditCardStatementViewPage"),
);
export const CreditCardPaymentPage = lazy(
  () => import("./cards/credit-card-payment/CreditCardPaymentPage"),
);
export const CreditCardPaymentConfirmPage = lazy(
  () => import("./cards/credit-card-payment/CreditCardPaymentConfirmPage"),
);
export const CardUnlockPage = lazy(
  () => import("./cards/card-unlock/CardUnlockPage"),
);
export const CardLockPage = lazy(
  () => import("./cards/card-lock/CardLockPage"),
);
export const CardOnlinePaymentPage = lazy(
  () => import("./cards/card-online-payment/CardOnlinePaymentPage"),
);
export const CardActionResultPage = lazy(
  () => import("./cards/card-action-result/CardActionResultPage"),
);
// export const AccountDetail = lazy(
//   () => import("./accounts/accounts-detail/AccountDetail")
// );
export const BillPayment = lazy(
  () => import("./payments/bill-payment/BillPayment"),
);
export const BillPaymentList = lazy(
  () => import("./payments/bill-payment/BillPaymentList"),
);
export const Notfications = lazy(() => import("./notications/Notifications"));
export const Setting = lazy(() => import("./setting/Setting"));
export const UserProfile = lazy(
  () => import("../modules/setting/components/UserProfile"),
);
export const ChangePassword = lazy(
  () => import("../modules/setting/components/ChangePassword"),
);
export const CurrentLimit = lazy(
  () => import("../modules/setting/components/CurrentLimit"),
);
export const DeviceManagement = lazy(
  () => import("../modules/setting/components/DeviceManagement"),
);
export const NotificationSettings = lazy(
  () => import("../modules/setting/components/NotificationSettings"),
);
export const About = lazy(() => import("../modules/setting/components/About"));
export const TermsAndConditions = lazy(
  () => import("../modules/setting/components/TermAndConditionsContainer"),
);
export const OpenCurrentAccount = lazy(
  () => import("../modules/setting/components/DeviceManagement"),
);

export const ManagerTermDeposits = lazy(
  () => import("./term-deposit/manager-term-deposits/ManagerTermDeposits"),
);

export const TermDepositDetail = lazy(
  () => import("./term-deposit/term-deposit-detail/TermDepositDetail"),
);

export const FinalizeDeposit = lazy(
  () => import("./term-deposit/finalize-deposit/FinalizeDeposit"),
);

export const FinalizeDepositDetail = lazy(
  () => import("./term-deposit/finalize-deposit-detail/FinalizeDepositDetail"),
);

export const WithdrawAccount = lazy(
  () => import("./term-deposit/withdraw-account/WithdrawAccount"),
);

export const RootWithdrawal = lazy(
  () => import("./term-deposit/root-withdrawal/RootWithdrawal"),
);

export const WithdrawAccountResponse = lazy(
  () =>
    import("./term-deposit/withdraw-account-response/WithdrawAccountResponse"),
);

export const ApproveFinalSettlement = lazy(
  () =>
    import("./term-deposit/approve-final-settlement/ApproveFinalSettlement"),
);

export const ApproveFinalSettlementResponse = lazy(
  () =>
    import(
      "./term-deposit/approve-final-settlement/ApproveFinalSettlementResponse"
    ),
);

export const CosumerLoan = lazy(() => import("./term-loan/TermLoan"));
export const TransactionResponse = lazy(
  () => import("./transaction-response/TransactionResponse"),
);

export const Disbursement = lazy(
  () => import("./credit/disbursement/Disbursement"),
);

export const AddDisbursement = lazy(
  () => import("./credit/disbursement/add/AddDisbursement"),
);

export const DisbursementDetail = lazy(
  () => import("./credit/disbursement/detail/DisbursementDetail"),
);

export const LoanManagementList = lazy(
  () => import("./loan-management/LoanList"),
);

export const LoanManagementDetail = lazy(
  () => import("./loan-management/LoanDetail"),
);

export const LoanManagementClosure = lazy(
  () => import("./loan-management/LoanClosure"),
);

export const LoanManagementPayment = lazy(
  () => import("./loan-management/LoanPayment"),
);

export const ForeignCurrencyExchangePage = lazy(
  () => import("./foreign-currency-exchange/ForeignCurrencyExchange"),
);

export const DomesticTaxPaymentPage = lazy(
  () => import("./domestic-tax-payment/DomesticTaxPayment"),
);

export const CustomsDutyPaymentPage = lazy(
  () => import("./customs-duty-payment/CustomsDutyPayment"),
);

export const SellForeignCurrencyPage = lazy(
  () => import("./foreign-currency/sell-foreign-currency/SellForeignCurrency"),
);

export const LetterOfCreditPage = lazy(
  () => import("./letter-of-credit/LetterOfCredit"),
);

export const LetterOfCreditDetailPage = lazy(
  () => import("./letter-of-credit/LetterOfCreditDetail"),
);

export const ShippingDocumentsPage = lazy(
  () => import("./shipping-documents/ShippingDocuments"),
);
export const ShippingDocumentsDetail = lazy(
  () => import("./shipping-documents/ShippingDocumentsDetail"),
);

export const GuaranteePage = lazy(() => import("./guarantee/Guarantee"));
export const GuaranteeDetailPage = lazy(
  () => import("./guarantee/GuaranteeDetail"),
);

export const GuaranteeIssuancePage = lazy(
  () => import("./guarantee-issuance/GuaranteeIssuance"),
);

// Bảo lãnh dự thầu (AW122) — bốn màn mới, tách khỏi màn Bảo lãnh cũ
export const GuaranteeListAw122Page = lazy(
  () => import("./guarantee-aw122/GuaranteeListAw122"),
);
export const GuaranteeRequestDetailPage = lazy(
  () => import("./guarantee-aw122/GuaranteeRequestDetail"),
);
export const GuaranteeApprovalListPage = lazy(
  () => import("./guarantee-aw122/GuaranteeApprovalList"),
);
export const GuaranteeApprovePage = lazy(
  () => import("./guarantee-aw122/GuaranteeApprove"),
);
export const GuaranteeLetterDetailPage = lazy(
  () => import("./guarantee-aw122/GuaranteeLetterDetail"),
);

export const GuaranteeIssueStep1Page = lazy(
  () => import("./guarantee-aw122/GuaranteeIssueStep1"),
);
export const GuaranteeIssueStep2Page = lazy(
  () => import("./guarantee-aw122/GuaranteeIssueStep2"),
);
export const GuaranteeIssueStep3Page = lazy(
  () => import("./guarantee-aw122/GuaranteeIssueStep3"),
);
export const GuaranteeIssueStep4Page = lazy(
  () => import("./guarantee-aw122/GuaranteeIssueStep4"),
);
export const GuaranteeIssueResultPage = lazy(
  () => import("./guarantee-aw122/GuaranteeIssueResult"),
);
export const GuaranteeSupplementPage = lazy(
  () => import("./guarantee-aw122/GuaranteeSupplement"),
);
export const RegistartionFreePage = lazy(
  () => import("./registration-fee/RegistrationFee"),
);
export const NopNsnnOverviewPage = lazy(
  () => import("./nop-nsnn/NopNsnnOverviewPage"),
);
export const MortgageLoanAccountPage = lazy(
  () => import("./mortgage-loan-account/MortgageLoanAccount"),
);
export const ConvenienceServicesPage = lazy(
  () => import("./convenience-services/ConvenienceServices"),
);
export const BookingList = lazy(() => import("./booking/Booking"));

export const RequirementsManagementPage = lazy(
  () => import("./requirements-management/RequirementsManagementPage"),
);

export const UserManagementPage = lazy(
  () => import("./user-management/UserManagementPage"),
);
export const PermissionManagementPage = lazy(
  () => import("./permission-management/PermissionManagementPage"),
);

export const LetterOfCreditOpenedPage = lazy(
  () => import("./letter-credit/LetterCreditOpenedPage"),
);

export const LetterOfCreditOnlinePage = lazy(
  () => import("./letter-credit/LetterCreditOnlinePage"),
);
export const InfoBusinessPage = lazy(
  () => import("./info-business/InfoBusinessPage"),
);
export const TermDepositListPage = lazy(
  () => import("./savings/TermDepositListPage"),
);

export const TermDepositDetailPage = lazy(
  () => import("./savings/TermDepositDetailPage"),
);

export const TransHistoryDetailPage = lazy(
  () => import("./accounts/accounts-detail/TransHistoryDetail"),
);

export const PartialWithdrawalPage = lazy(
  () => import("./partial-withdrawal/PartialWithdrawalPage"),
);

export const DepositTopupPage = lazy(
  () => import("./deposit-topup/DepositTopupPage"),
);
export const ListSavingsPage = lazy(() => import("./savings/SavingListPage"));
export const OnboardingPage = lazy(
  () => import("../modules/onboarding/OnboardingPage"),
);
export const CorpOnboardingPage = lazy(
  () => import("../modules/corp-onboarding/CorpOnboardingPage"),
);
export const HkdAccountsPage = lazy(() => import("./hkd-accounts/HkdAccountsPage"));
export const HkdTransferPage = lazy(() => import("./hkd-transfer/HkdTransferPage"));
export const HkdQrPaymentPage = lazy(() => import("./hkd-qr/HkdQrPage"));
export const HkdEInvoicePage = lazy(() => import("./hkd-einvoice/HkdEInvoicePage"));
export const HkdReportPage = lazy(() => import("./hkd-report/HkdReportPage"));
export const HkdLoaPage = lazy(() => import("./hkd-loa/HkdLoaPage"));
export const HkdPackagePage = lazy(() => import("./hkd-package/HkdPackagePage"));
export const HkdDomesticTaxPage = lazy(() => import("./hkd-nsnn/HkdDomesticTaxPage"));
export const HkdRegistrationFeePage = lazy(() => import("./hkd-nsnn/HkdRegistrationFeePage"));

export const ForceChangePasswordPage = lazy(
  () => import("./change-password/ChangePasswordPage"),
);
const RoutesString = {
  Dashboard: `/${PAGES_URL.DASHBOARD}`,
  AccountsList: `/${PAGES_URL.ACCOUNTS_LIST}`,
  Accounts: `/${PAGES_URL.ACCOUNTS}`,
  AccountsDetail: `/${PAGES_URL.ACCOUNT_DETAIL}`,
  CardsList: `/${PAGES_URL.CARDS_LIST}`,
  Cards: `/${PAGES_URL.CARDS}`,
  CardsDetail: `/${PAGES_URL.CARD_DETAIL}`,
  CardsDetailWithId: `/${PAGES_URL.CARD_DETAIL}/:cardId`,
  CardsCreditDetail: `/${PAGES_URL.CARD_CREDIT_DETAIL}`,
  CardsCreditDetailWithId: `/${PAGES_URL.CARD_CREDIT_DETAIL}/:cardId`,
  CardTransactionHistory: `/${PAGES_URL.CARD_TRANSACTION_HISTORY}`,
  CardTransactionHistoryWithId: `/${PAGES_URL.CARD_TRANSACTION_HISTORY}/:cardId`,
  CardTransactionDetail: `/${PAGES_URL.CARD_TRANSACTION_DETAIL}`,
  CardTransactionDetailWithId: `/${PAGES_URL.CARD_TRANSACTION_DETAIL}/:cardId/:transId`,
  CardLimitSetting: `/${PAGES_URL.CARD_LIMIT_SETTING}`,
  CardLimitSettingWithId: `/${PAGES_URL.CARD_LIMIT_SETTING}/:cardId`,
  CardStatement: `/${PAGES_URL.CARD_STATEMENT}`,
  CardStatementWithId: `/${PAGES_URL.CARD_STATEMENT}/:cardId`,
  CardStatementView: `/${PAGES_URL.CARD_STATEMENT_VIEW}`,
  CardPayment: `/${PAGES_URL.CARD_PAYMENT}`,
  CardPaymentWithId: `/${PAGES_URL.CARD_PAYMENT}/:cardId`,
  CardPaymentConfirm: `/${PAGES_URL.CARD_PAYMENT_CONFIRM}`,
  CardUnlock: `/${PAGES_URL.CARD_UNLOCK}`,
  CardUnlockWithId: `/${PAGES_URL.CARD_UNLOCK}/:cardId`,
  CardLock: `/${PAGES_URL.CARD_LOCK}`,
  CardLockWithId: `/${PAGES_URL.CARD_LOCK}/:cardId`,
  CardOnlinePayment: `/${PAGES_URL.CARD_ONLINE_PAYMENT}`,
  CardOnlinePaymentWithId: `/${PAGES_URL.CARD_ONLINE_PAYMENT}/:cardId`,
  CardActionResult: `/${PAGES_URL.CARD_ACTION_RESULT}`,
  AccountsDetailWithId: `/${PAGES_URL.ACCOUNT_DETAIL}/:accountId`,
  TransferByPhone: `/${PAGES_URL.TRANFER_BY_PHONE}`,
  TransferByAccount: `/${PAGES_URL.TRANFER_BY_ACCOUNT}`,
  TransferByCard: `/${PAGES_URL.TRANFER_BY_CARD}`,
  TransferByBatch: `/${PAGES_URL.TRANFER_BY_BATCH}`,
  CardTransactionList: `/${PAGES_URL.CARD_TRANSACTION_LIST}`,
  TransactionList: `/${PAGES_URL.TRANSACTION_LIST}`,
  BeneficiaryTemplate: `/${PAGES_URL.BENEFICIARY_TEMPLATE}`,
  TransInternational: `/${PAGES_URL.TRANS_INTERNATIONAL}`,

  // TransactionDomestic: `${PAGES_URL.GET_LIST_DOMESTIC_BANK}`,
  TransactionDetail: `/${PAGES_URL.TRANSACTION_DETAIL}`,
  TransactionResponse: `/${PAGES_URL.TRANSACTION_RESPONSE}`,
  TransactionDetailWithId: `/${PAGES_URL.TRANSACTION_DETAIL}/:transId`,
  TransactionHistory: `/${PAGES_URL.TRANSACTION_LIST}`,
  BillPayment: `/${PAGES_URL.BILL_PAYMENT}`,
  BillPaymentList: `/${PAGES_URL.BILL_PAYMENT_LIST}`,
  Login: `/${PAGES_URL.LOGIN}`,
  PreLogin: `/${PAGES_URL.PRE_LOGIN}`,
  Support: `/${PAGES_URL.SUPPORT}`,
  Forgotpassword: `/${PAGES_URL.FORGOTPASSWORD}`,
  NotFound: `/${PAGES_URL.NOT_FOUND}`,
  StylesGuide: `/${PAGES_URL.STYLES_GUIDE}`,
  Notifications: `/${PAGES_URL.NOTIFICATIONS}`,

  Setting: `/${PAGES_URL.SETTING}`,
  UserProfile: `/${PAGES_URL.USER_PROFILE}`,
  ChangePassword: `/${PAGES_URL.CHANGE_PASSWORD}`,
  UserLimit: `/${PAGES_URL.USER_LIMIT}`,
  DeviceManager: `/${PAGES_URL.DEVICE_MANAGEMENT}`,
  NotificationSettings: `/${PAGES_URL.NOTIFICATION_SETTINGS}`,
  About: `/${PAGES_URL.ABOUT}`,
  TermsAndConditions: `/${PAGES_URL.TERMS_AND_CONDITIONS}`,
  OpenCurrentAccount: `/${PAGES_URL.OPEN_CURRENT_ACCOUNT}`,
  TermDepositForm: `/${PAGES_URL.TERM_DEPOSIT_FORM}`,
  TermDeposit: `/${PAGES_URL.TERM_DEPOSIT}`,
  TermDepositCreate: `/${PAGES_URL.TERM_DEPOSIT_CREATE}`,
  TermDepositDetail: `/${PAGES_URL.TERM_DEPOSIT_DETAIL}`,
  FinalizeDeposit: `/${PAGES_URL.FINALIZE_DEPOSIT}`,
  WithdrawAccount: `/${PAGES_URL.WITHDRAW_ACCOUNT}`,
  RootWithdrawal: `/${PAGES_URL.ROOT_WITHDRAWAL}`,
  WithdrawAccountResponse: `/${PAGES_URL.WITHDRAW_ACCOUNT_RESPONSE}`,
  ApproveFinalSettlement: `/${PAGES_URL.APPROVE_FINAL_SETTLEMENT}`,
  ApproveFinalSettlementResponse: `/${PAGES_URL.APPROVE_FINAL_SETTLEMENT_RESPONSE}`,
  TermLoan: `/${PAGES_URL.TERM_LOAN}`,
  TermCosumerLoan: `/${PAGES_URL.TERM_COSUMER_LOAN}`,
  TermLoanDetail: `/${PAGES_URL.TERM_LOAN_DETAIL}`,
  TermLoanSettlement: `/${PAGES_URL.TERM_LOAN_SETTLEMENT}`,
  TermLoanSettlementResponse: `/${PAGES_URL.TERM_LOAN_SETTLEMENT_RESPONSE}`,
  TermDepositSettlement: `/${PAGES_URL.TERM_DEPOSIT_SETTLEMENT}`,
  Disbursement: `/${PAGES_URL.DISBURSEMENT}`,
  AddDisbursement: `/${PAGES_URL.ADD_DISBURSEMENT}`,
  DisbursementDetail: `/${PAGES_URL.DISBURSEMENT_DETAIL}`,
  LoanList: `/${PAGES_URL.LOAN_MANAGEMENT}`,
  LoanDetail: `/${PAGES_URL.LOAN_MANAGEMENT_DETAIL}`,
  LoanClosure: `/${PAGES_URL.LOAN_MANAGEMENT_CLOSURE}`,
  LoanPayment: `/${PAGES_URL.LOAN_MANAGEMENT_PAYMENT}`,
  ForeignCurrencyExchangePage: `/${PAGES_URL.FOREIGN_CURRENCY_EXCHANGE}`,
  DomesticTaxPaymentPage: `/${PAGES_URL.DOMESTIC_TAX_PAYMENT}`,
  CustomsDutyPaymentPage: `/${PAGES_URL.CUSTOMS_DUTY_PAYMENT}`,
  SellForeignCurrencyPage: `/${PAGES_URL.SELL_FOREIGN_CURRENCY}`,
  LetterOfCreditPage: `/${PAGES_URL.LETTER_OF_CREDIT}`,
  LetterOfCreditDetailPage: `/${PAGES_URL.LETTER_OF_CREDIT_DETAIL}`,
  ShippingDocumentsPage: `/${PAGES_URL.SHIPPING_DOCUMENTS}`,
  ShippingDocumentsDetail: `/${PAGES_URL.SHIPPING_DOCUMENTS_DETAIL}`,
  GuaranteePage: `/${PAGES_URL.GUARANTEE}`,
  GuaranteeDetailPage: `/${PAGES_URL.GUARANTEE_DETAIL}`,
  GuaranteeIssuancePage: `/${PAGES_URL.GUARANTEE_INSURANCE}`,
  GuaranteeListAw122Page: `/${PAGES_URL.GUARANTEE_AW122}`,
  GuaranteeRequestDetailPage: `/${PAGES_URL.GUARANTEE_REQUEST_DETAIL}`,
  GuaranteeApprovalListPage: `/${PAGES_URL.GUARANTEE_APPROVAL_LIST}`,
  GuaranteeApprovePage: `/${PAGES_URL.GUARANTEE_APPROVE}`,
  GuaranteeLetterDetailPage: `/${PAGES_URL.GUARANTEE_LETTER_DETAIL}`,
  GuaranteeIssueStep1Page: `/${PAGES_URL.GUARANTEE_ISSUE_STEP1}`,
  GuaranteeIssueStep2Page: `/${PAGES_URL.GUARANTEE_ISSUE_STEP2}`,
  GuaranteeIssueStep3Page: `/${PAGES_URL.GUARANTEE_ISSUE_STEP3}`,
  GuaranteeIssueStep4Page: `/${PAGES_URL.GUARANTEE_ISSUE_STEP4}`,
  GuaranteeIssueResultPage: `/${PAGES_URL.GUARANTEE_ISSUE_RESULT}`,
  GuaranteeSupplementPage: `/${PAGES_URL.GUARANTEE_SUPPLEMENT}`,
  RegistartionFreePage: `/${PAGES_URL.REGISTARTION_FREE}`,
  NopNsnnOverview: `/${PAGES_URL.NOP_NSNN_OVERVIEW}`,
  MortgageLoanAccountPage: `/${PAGES_URL.MORTGAGE_LOAN_ACCOUNT}`,
  ConvenienceServicesPage: `/${PAGES_URL.CONVENIENCE_SERVICES}`,
  BookingList: `/${PAGES_URL.BOOKING_LIST}`,
  RequirementsManagementPage: `/${PAGES_URL.REQUIREMENTS_MANAGEMENT}`,
  UserManagementPage: `/${PAGES_URL.USER_MANAGEMENT}`,
  LetterOfCreditOpenedPage: `/${PAGES_URL.LETTER_OF_CREDIT_OPENED}`,
  LetterOfCreditOnlinePage: `/${PAGES_URL.LETTER_OF_CREDIT_ONLINE}`,
  InfoBusinessPage: `/${PAGES_URL.INFO_BUSINESS_PAGE}`,
  PermissionManagementPage: `/${PAGES_URL.PERMISSION_MANAGEMENT}`,
  // savings
  TermDepositList: `/${PAGES_URL.TERM_DEPOSIT_LIST}`,
  TermDetail: `/${PAGES_URL.TERM_DETAIL}`,
  LockDetail: `/${PAGES_URL.LOCK_DETAIL}`,
  LockCheckerDetail: `/${PAGES_URL.LOCK_CHECKER_DETAIL}`,
  TransHistoryDetail: `/${PAGES_URL.TRANS_HISTORY_DETAIL}`,
  ListSavings: `/${PAGES_URL.LIST_SAVINGS}`,
  DepositSettlement: `/${PAGES_URL.DEPOSIT_SETTLEMENT_SAVINGS}`,
  PartialWithdrawal: `/${PAGES_URL.PARTIAL_WITHDRAWAL}`,
  DepositTopupPage: `/${PAGES_URL.DEPOSIT_TOPUP}`,
  Onboarding: `/${PAGES_URL.ONBOARDING}`,
  CorpOnboarding: `/${PAGES_URL.CORP_ONBOARDING}`,
  ForceChangePassword: `/${PAGES_URL.FORCE_CHANGE_PASSWORD}`,

  // HKD (MERCHANT) pages
  HkdAccounts: "/hkd/accounts",
  HkdTransfer: "/hkd/transfer",
  HkdQrPayment: "/hkd/qr-payment",
  HkdLoa: "/hkd/loa",
  HkdPackage: "/hkd/package",
  HkdReport: "/hkd/report",
  HkdDomesticTax: "/hkd/nsnn/domestic-tax",
  HkdRegistrationFee: "/hkd/nsnn/registration-fee",
  HkdEInvoice: "/hkd/einvoice",
};

export default RoutesString;
